import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/schedule',
    meta: {
      protected: true
    }
  },

  //Information views
  {
    path: '/request-status',
    name: 'Request status',
    meta: {
      title: 'Estado de la revisión',
      protected: true
    },
    component: () => import('@/views/info/RegisterStatus.vue')
  },
  {
    path: '/consultory-sent',
    name: 'Consultory sent',
    meta: {
      title: 'Consultorio enviado',
      protected: true
    },
    component: () => import('@/views/info/ConsultorySent.vue')
  },
  //Signin and register routes
  {
    path: '/signin',
    name: 'signin',
    meta: {
      title: 'Acceder',
      protected: false
    },
    component: () => import('@/views/signIn/SignIn.vue')
  },
  //Validate user route
  {
    path: '/validate',
    name: 'validate',
    meta: {
      title: 'Validar usuario',
      protected: true
    },
    component: () => import('@/views/signIn/ValidateUserStatus.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: 'Registro',
      protected: true
    },
    component: () => import('@/views/register/Register.vue')
  },
  //Today routes
  {
    path: '/today',
    name: 'home',
    meta: {
      title: 'Inicio',
      protected: true,
      menu: 1
    },
    component: () => import('@/views/today/TodayView.vue')
  },

  //Schedule routes
  {
    path: '/schedule',
    name: 'schedule',
    meta: {
      title: 'Agenda',
      protected: true,
      menu: 2
    },
    component: () => import('@/views/schedule/ScheduleView.vue')
  },

  //Patient routes
  {
    path: '/patients',
    name: 'patients',
    meta: {
      title: 'Pacientes',
      protected: true,
      menu: 3
    },
    component: () => import('@/views/patient/PatientsView.vue')
  },
  {
    path: '/patients/:id',
    name: 'patient',
    meta: {
      title: 'Detalles del paciente',
      protected: true,
      menu: 3
    },
    component: () => import('@/views/patient/PatientDetailsView.vue')
  },
  {
    path: '/patients/:patientId/consultation/:eventId',
    name: 'patientConsultation',
    meta: {
      title: 'Detalles de la consulta',
      protected: true,
      menu: 3
    },
    component: () => import('@/views/patient/PatientCurrentConditionView.vue')
  },
  {
    path: '/patients/:patientId/clinicalHistory',
    name: 'patientClinicalHistory',
    meta: {
      title: 'Historial clinico',
      protected: true,
      menu: 3
    },
    component: () => import('@/views/patient/PatientClinicalHistoryView.vue')
  },
  {
    path: '/patients/:patientId/obstetricEvent/:obstetricEventId',
    name: 'patientObstetricEvent',
    meta: {
      title: 'Evento obstétrico',
      protected: true,
      menu: 3
    },
    component: () => import('@/views/patient/PatientObstetricEventView.vue')
  },
  {
    path: '/patients/:patientId/morbidityRegistry/:morbidityRegistryId',
    name: 'patientMorbidityRegistry',
    meta: {
      title: 'Registro de morbilidad',
      protected: true,
      menu: 3
    },
    component: () => import('@/views/patient/PatientMorbidityRegistryView.vue')
  },

  //Profile routes
  {
    path: '/profile',
    name: 'profile',
    meta: {
      title: 'Perfil',
      protected: true,
      menu: 1
    },
    component: () => import('@/views/profile/ProfileView.vue')
  },
  {
    path: '/consultory/create',
    name: 'create-consultory',
    meta: {
      title: 'Crear consultorio',
      protected: true,
      menu: 1
    },
    component: () => import('@/views/profile/CreateConsultoryView.vue')
  },

  //Administration routes
  {
    path: '/admin',
    name: 'admin',
    meta: {
      title: 'Administrativo',
      protected: true,
      menu: 4
    },
    component: () => import('@/views/admin/AdminView.vue')
  },

  //Notifications routes
  {
    path: '/notifications',
    name: 'notifications',
    meta: {
      title: 'Notificaciones',
      protected: true,
      menu: 5
    },
    component: () => import('@/views/notifications/NotificationsView.vue')
  },

  //Consultories routes
  {
    path: '/consultory/:id/modules',
    name: 'modules',
    meta: {
      title: 'Modulos del consultorio',
      protected: true,
      menu: 1
    },
    component: () => import('@/views/profile/consultory/ConsultoryModules.vue')
  },
  {
    path: '/consultory/:consultoryId/module/:moduleId/schedule',
    name: 'module-schedule',
    meta: {
      title: 'Configurar horarios',
      protected: true,
      menu: 1
    },
    component: () => import('@/views/profile/consultory/ConfigureSchedule.vue')
  },
  {
    path: '/consultory/:consultoryId/module/:moduleId/schedule-edit',
    name: 'module-schedule-edit',
    meta: {
      title: 'Configurar horarios',
      protected: true,
      menu: 1
    },
    component: () =>
      import('@/views/profile/consultory/ConfigureScheduleWeek.vue')
  },
  {
    path: '/consultory/:consultoryId/module/:moduleId/configure-appointments',
    name: 'config-appointments',
    meta: {
      title: 'Configurar citas',
      protected: true,
      menu: 1
    },
    component: () =>
      import('@/views/profile/consultory/ConfigureAppointments.vue')
  },
  {
    path: '/consultory/:consultoryId/modules/:moduleId/doctors',
    name: 'module-doctors',
    meta: {
      title: 'Configurar doctores del consultorio',
      protected: true,
      menu: 1
    },
    component: () => import('@/views/profile/consultory/ConsultoryDoctors.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

import { NavigationMutations } from '@/store/navigation/mutations'
import firebase from 'firebase/app'
import 'firebase/auth'

router.beforeEach(async (to, _, next) => {
  window.document.title = 'Luminé | ' + to?.meta?.title

  const protectedRoute = to.matched.some(record => record.meta.protected)
  const menuRoute = to.matched.some(record => record.meta.menu)
  const firebaseUser = await waitForAuthReady()
  const isAuthenticated = !!firebaseUser
  const currentPath = to.path
  const excludedPaths = ['/validate', '/register', '/request-status']
  const isPathExcluded = excludedPaths.includes(currentPath)

  if (menuRoute) {
    store.commit(
      'navigation/' + NavigationMutations.SET_SELECTED_MENU,
      to.meta?.menu
    )
  }

  if (isPathExcluded) {
    if (!protectedRoute) {
      next({ name: 'schedule' })
    } else {
      next()
    }
  } else {
    if (protectedRoute) {
      if (isAuthenticated) {
        next()
      } else {
        next({ name: 'signin' })
      }
    } else {
      if (isAuthenticated) {
        next({ name: 'schedule' })
      } else {
        next()
      }
    }
  }
})

function waitForAuthReady(): Promise<firebase.User | null> {
  return new Promise(resolve => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    })
  })
}

export default router
